import React from "react";
import { Link } from "react-router-dom";
import Wordmark from "../wordmark/Wordmark";

export default function NotFound() {
  return (
    <div className="page">
      <div className="status" style={{ flexDirection: "column", gap: 20 }}>
        <Wordmark text="not found" size={15} />
        <p className="prose" style={{ textAlign: "center" }}>
          That page doesn’t exist.{" "}
          <Link to="/" style={{ textDecoration: "underline" }}>
            Back to the work
          </Link>
          .
        </p>
      </div>
    </div>
  );
}